export const insuranceAgentNavConfig = [];
